import { render, staticRenderFns } from "./TorListe.vue?vue&type=template&id=1ad8181e&"
import script from "./TorListe.vue?vue&type=script&lang=js&"
export * from "./TorListe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports